import React from "react";

export default function ProgressBar({
  title,
  percentage,
  current,
  total,
  barColor = "#00306b",
  trackColor = "#f3f4f6",
  showPercentage = true,
  titleColor = "text-gray-800",
  percentageColor = "text-gray-900",
}) {
  const finalPercentage =
    percentage !== undefined && percentage !== null
      ? percentage
      : current && total
        ? Math.round((current / total) * 100)
        : 0;

  const displayTitle =
    title || (current && total ? `${current} / ${total} Taksit` : "");

  return (
    <div className="space-y-1.5 mt-6 mb-4">
      <div className="flex justify-between items-baseline text-xs font-medium">
        <span className={`text-base ${titleColor}`}>{displayTitle}</span>

        {showPercentage && (
          <span className={`text-base font-semibold ${percentageColor}`}>
            %{finalPercentage}
          </span>
        )}
      </div>

      <div
        className="w-full rounded-full h-2 overflow-hidden"
        style={{ backgroundColor: trackColor }}
      >
        <div
          className="h-2 rounded-full transition-all duration-500 ease-out"
          style={{
            width: `${finalPercentage}%`,
            backgroundColor: barColor,
          }}
        ></div>
      </div>
    </div>
  );
}
